"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("history");
var ElstrCore = /** @class */ (function () {
    function ElstrCore() {
    }
    ElstrCore.history = history_1.createBrowserHistory();
    return ElstrCore;
}());
exports.default = ElstrCore;
exports.dispatch = function (foo) { return ElstrCore.store.dispatch(foo); };
//# sourceMappingURL=ElstrCore.js.map